<tidy-card class="subtle-zoom">
  <tidy-card-button (action)="onMessageCardClick()" class="arrow-to-top">
    <div class="avatar-section">
      <div class="avatar-container">
        <div class="avatar" [style.background]="util.getAvatarGradient(initials)">
          @if (!isUnknownNumber) {
            <tidy-text
              [body]="initials" />
          }
          @if (isUnknownNumber) {
            <tidy-image
              [src]="'assets/img/person-white.svg'"
              style="display: flex; align-items: center; justify-content: center; width: 75%; height: 75%; margin: auto;" />
          }
        </div>
        @if (type === 'call') {
          <div class="notification-bubble">
            @if (type === 'call') {
              <mat-icon>call_outline</mat-icon>
            }
            <!--<mat-icon *ngIf="type === 'chat'">chat_bubble_outline</mat-icon>
            <mat-icon *ngIf="type === 'email'">mail_outline</mat-icon>
            <mat-icon *ngIf="type === 'proxy'">person_outline</mat-icon>
            <mat-icon *ngIf="type === 'homekeeper_job'">work_outline</mat-icon>-->
          </div>
        }
        @if (messageCategory === 'guest') {
          <div class="category-badge guest-badge">
            <mat-icon class="badge-icon">home</mat-icon>
          </div>
        }
        @if (messageCategory === 'pro') {
          <div class="category-badge pro-badge">
            <mat-icon class="badge-icon">work</mat-icon>
          </div>
        }
        @if (messageCategory === 'unknown' && type === 'proxy') {
          <div class="category-badge unknown-badge" [matTooltip]="'Message type unknown - incomplete data' | translate" [matTooltipPosition]="'above'">
            <mat-icon class="badge-icon">help_outline</mat-icon>
          </div>
        }
      </div>
      <div class="message-content">
        <div class="name-and-date">
          <div class="name-with-contact">
            <tidy-text [body]="'<b>' + message.displayName + '</b>'" />
            @if (contactInfo?.showCategorySuffix && contactInfo?.category) {
              <tidy-text [body]="('&nbsp;(' | translate) + contactInfo.category + ')'" class="category-suffix" />
            }
          </div>
          <tidy-text [helper]="date" />
        </div>
        <div class="message-text" [class.unread]="isUnread" [innerHTML]="message.message | linkify | enrichLinks">
        </div>
        @if (files && files.length > 0) {
          <div class="files-container">
            @for (file of files | slice:0:4; track file) {
              @if (file | isImageUrl) {
                <img [src]="file" class="message-image" loading="eager" (click)="$event.stopPropagation(); $event.preventDefault(); openImagePreview(file)" />
              } @else {
                <div class="message-file" (click)="openFile($event, file)">
                  <img src="assets/svg/document-outline.svg" class="message-file-icon" />
                  <span class="message-file-name">{{ file | filenameFromUrl }}</span>
                </div>
              }
            }
            @if (files.length > 4) {
              <div class="more-files-badge">+{{ files.length - 4 }}</div>
            }
          </div>
        }
      </div>
      <!--
      <div class="content-section" *ngIf="isDesktopRes">
        <div class="tags">
          <ion-chip *ngFor="let tag of tags; trackBy: trackByTag" class="tag-chip">
            <tidy-text [body]="tag | titlecase" class="tag-text"></tidy-text>
          </ion-chip>
        </div>
        <div class="date">
          <tidy-text [body]="date" class="date-text"></tidy-text>
        </div>
      </div>
      <div class="content-section" style="margin-top: 1rem;" *ngIf="!isDesktopRes">
        <div class="tags">
          <ion-chip *ngFor="let tag of tags; trackBy: trackByTag" class="tag-chip">
            <tidy-text [body]="tag | titlecase" class="tag-text"></tidy-text>
          </ion-chip>
        </div>
        <div class="date">
          <tidy-text [body]="date" class="date-text"></tidy-text>
        </div>
      </div>
      -->
    </div>
  </tidy-card-button>
</tidy-card>

<!-- Image Preview Modal -->
<image-preview
  [isOpen]="showImagePreview"
  [imageSrc]="previewImageSrc"
  (dismiss)="onImagePreviewDismiss()" />
